
import validate from '@/javascript/validate.js'
import payPublic from '@/javascript/payPublic'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import { mapGetters, mapActions } from 'vuex'
import util from "@/javascript/util"
import axios from "axios"
import loadedTip from '@/components/public-components/loaded-tip/index.vue'

export default {
name: 'addContact',
components: {
PopupPicker,
Datetime,
loadedTip
},
data() {
return {
minHeight: 0,
isbur: false,
isbur_phone: false,
username: "",
phone: "",
birthDate: '请选择',
gender: [
['男','女']
],
genderData: [],
isMy: false,
papers: [
['身份证','护照','军人证','学生证','台胞证','港澳通行证','大陆居民来往台湾通行证']
],
list: [{
codeType: ['身份证'],
codeNumber: ''
}],
tabIndex:this.$route.query.tabIndex?parseInt(this.$route.query.tabIndex):-1,
objData:this.$route.query.objData?JSON.parse(this.$route.query.objData):{},
idCard:'',
passport:'',
taiwanCompatriotCertificate:'',
militaryCard:'',
studentCard:'',
hongkongAcaoPass:'',
taiwanPass:'',
repeatShow:false,
dilogShow:false,
tipsShow:false
}
},
computed: {
...mapGetters([
'contact', 'contactId'
])
},
mounted() {
this.minHeight = document.documentElement.clientHeight
if(this.tabIndex!=-1){
document.title = '编辑联系人'
this.addOrEdit()
}else{
document.title = '新增联系人'
}
/**
* 微信签名分享
*/
if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: this.PAGE_TITLE,
desc: this.SHARE_TEXT,
imgUrl: this.SHARE_IMG,
link: window.location.href.split('#')[0]
} : shareData
this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + this.WX_APPID).then(res => {
util.initWxConfig(res.data.data, shareData)
})
}
},
methods: {
...mapActions([
'setContact'
]),
addOrEdit(){
const _this = this
if (payPublic.isClient()) {
payPublic.hasToken(function () {
const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
if(userInfo){
_this.editWay(userInfo)
}else{
_this.$router.go(-1)
}
})
} else {
payPublic.loginCheck(function () {
const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
_this.editWay(userInfo)
})
}
},
editWay(info){
const _this = this
_this.list = []
_this.$http.get('/api/wtcp-member/public/contacts/'+_this.objData.id + '?access_token=' + info.access_token+'&userId='+info.user.id).then((response) => {
if (response.data.status === 1) {
const data = response.data.data
_this.username = data.name
_this.phone = data.phone
_this.genderData = data.sex==1?['男']:data.sex==2?['女']:[]
_this.birthDate = data.birthday
_this.isMy = data.acquiesce==1?true:false
if(data.idCard){
_this.list.push({
codeType: ['身份证'],
codeNumber: data.idCard
})
}
if(data.passport){
_this.list.push({
codeType: ['护照'],
codeNumber: data.passport
})
}
if(data.taiwanCompatriotCertificate){
_this.list.push({
codeType: ['台胞证'],
codeNumber: data.taiwanCompatriotCertificate
})
}
if(data.militaryCard){
_this.list.push({
codeType: ['军人证'],
codeNumber: data.militaryCard
})
}
if(data.studentCard){
_this.list.push({
codeType: ['学生证'],
codeNumber: data.studentCard
})
}
if(data.hongkongAcaoPass){
_this.list.push({
codeType: ['港澳通行证'],
codeNumber: data.hongkongAcaoPass
})
}
if(data.taiwanPass){
_this.list.push({
codeType: ['大陆居民来往台湾通行证'],
codeNumber: data.taiwanPass
})
}
}
})
},
sexChange(value){
this.genderData = value
},
dateChange(value){
this.birthDate = value
},
cardChange(value,index){
const _this = this
let counIndex=0
_this.list.forEach((item,indexs)=>{
if(item.codeType.toString()){
if(item.codeType.toString() == value.toString()){
counIndex +=1
}
}

})
if(counIndex == 2){
_this.list[index].codeType=[]
payPublic.showPrompt('证件已添加')
}
},
/**
* 值发生变化时出现清空按钮
*/
show_close_user() {
if (this.username) {
this.isbur = true;
if(this.username.length >= 10){
this.username = this.username.substring(0,10)
}
} else {
this.isbur = false;
}
},
show_close_phone() {
const _this = this
if (_this.phone) {
_this.isbur_phone = true;
if(_this.phone.length >= 11){
_this.phone = _this.phone.substring(0,11)
}
} else {
_this.isbur_phone = false;
}
},
/**
* 点击清空用户名
*/
clear_username() {
this.username = ""
this.isbur = false
},
/**
* 点击清空电话
*/
clear_phone() {
this.phone = ""
this.isbur_phone = false
},

addOther() {
this.list.push({
codeType: [],
codeNumber: ''
});
},

deleteNode(i) {
this.list.splice(i, 1);
},
show_data(item) {
if (item.codeNumber) {
item.show = true;
} else {
item.show = false;
}
},

clear_data(item) {
item.show = false
item.codeNumber = ''
},
setMy(){
const _this = this
_this.isMy = !_this.isMy
},
confitBtn(){
const _this = this
if(_this.THE_CLIENT){
payPublic.hasToken(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if(userInfo) {
_this.deletelist(_this.objData,userInfo)
}else{
payPublic.goBack()
}
})
}else{
payPublic.loginCheck(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.deletelist(_this.objData,userInfo)
})
}
},
closeBtn(){
this.dilogShow=false
},
deletelist(item,info){
axios({
method: "delete",
url: '/api/wtcp-member/public/contacts/'+ item.id +'?access_token=' + info.access_token + '&userId=' + info.user.id,
}).then(res => {
if(res.data.status == 1){
this.dilogShow=false

this.$router.go(-1)
}
})
},

deleteMeth(){
this.dilogShow =true
},

saveMeth(){
const _this = this
if (payPublic.isClient()) {
payPublic.hasToken(function () {
const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
if(userInfo){
_this.publicWay(userInfo)
}else{
_this.$router.go(-1)
}
})
} else {
payPublic.loginCheck(function () {
const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
_this.publicWay(userInfo)
})
}
},
getBirthdayFromIdCard : function(idCard) {
var birthday = "";
if(idCard != null && idCard != ""){
if(idCard.length == 15){
birthday = "19"+idCard.substr(6,6);
} else if(idCard.length == 18){
birthday = idCard.substr(6,8);
}

birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
}

return birthday;
},
publicWay(info) {
console.log(info, '=====================================')
const _this = this
_this.idCard = ''
_this.passport = ''
_this.taiwanCompatriotCertificate = ''
_this.militaryCard = ''
_this.studentCard = ''
_this.hongkongAcaoPass = ''
_this.taiwanPass = ''
if(_this.list.length>0){
for(let i =0;i<_this.list.length;i++){
if(_this.list[i].codeType == ''){
payPublic.showPrompt('请输入证件类型')
return false;
}
if(_this.list[i].codeNumber == ''){
payPublic.showPrompt('请输入证件号')
return false;
}
}
}

if(_this.list.length>0){
_this.list.forEach((item)=>{
switch (item.codeType.toString()) {
case '身份证':
_this.idCard = item.codeNumber
break;
case '护照':
_this.passport = item.codeNumber
break;
case '台胞证':
_this.taiwanCompatriotCertificate = item.codeNumber
break;
case '军人证':
_this.militaryCard = item.codeNumber
break;
case '学生证':
_this.studentCard = item.codeNumber
break;
case '港澳通行证':
_this.hongkongAcaoPass = item.codeNumber
break;
case '大陆居民来往台湾通行证':
_this.taiwanPass = item.codeNumber
break;

default:
break;
}
})
}
let postData = {
description:'',
acquiesce:0,//是否默认
createdDate:'',
createdUser:'',
deptCode:_this.DEPT_CODE.DEPTCODE,//机构编码
hongkongAcaoPass:_this.hongkongAcaoPass,
id:'',
idCard:_this.idCard,
militaryCard:_this.militaryCard,
name:_this.username,//姓名
passport:_this.passport,
phone:_this.phone,//手机号码


studentCard:_this.studentCard,
taiwanCompatriotCertificate:_this.taiwanCompatriotCertificate,
taiwanPass:_this.taiwanPass,
updatedDate:'',
updatedUser:'',
userId:parseInt(info.user.id)
}
if (!postData.name|| !validate.noHtml(postData.name)) {
payPublic.showPrompt('请输入正确的姓名')
return;
}








if(!postData.phone || !validate.Mobile(postData.phone)){
payPublic.showPrompt('请输入正确的手机号')
return;
}
if(postData.idCard){
if (!postData.idCard || !validate.idNumber(postData.idCard)) {
payPublic.showPrompt('请输入正确的身份证号')
return;
}
}
if(postData.passport){
if (!postData.passport || !/^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/.test(postData.passport)) {
payPublic.showPrompt('请输入正确的护照号')
return;
}
}
if(postData.taiwanCompatriotCertificate){
if (!postData.taiwanCompatriotCertificate || !/(^\d{8})$/.test(postData.taiwanCompatriotCertificate)) {
payPublic.showPrompt('请输入正确的台胞证号')
return;
}
}
if(postData.hongkongAcaoPass){
if (!postData.hongkongAcaoPass || !/^([A-Z]\d{6,10}(\(\w{1}\))?)$/.test(postData.hongkongAcaoPass)) {
payPublic.showPrompt('请输入正确的港澳通行证号')
return;
}
}
if(postData.taiwanPass){
if (!postData.taiwanPass || !/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(postData.taiwanPass)) {
payPublic.showPrompt('请输入正确的台湾通行证号')
return;
}
}
if(postData.militaryCard){
if (!postData.militaryCard || !/^[a-zA-Z0-9]{7,21}$/.test(postData.militaryCard)) {
payPublic.showPrompt('请输入正确的军人证号')
return;
}
}
if(postData.studentCard){
if (!postData.studentCard || !/^[0-9]{6,16}$/.test(postData.studentCard)) {
payPublic.showPrompt('请输入正确的学生证号')
return;
}
}
if(_this.repeatShow){
return;
}

_this.tipsShow=true
_this.repeatShow = true
if(_this.tabIndex!= -1){
postData = _this.objData
postData.name=_this.username


postData.passport=_this.passport
postData.taiwanCompatriotCertificate=_this.taiwanCompatriotCertificate
postData.hongkongAcaoPass=_this.hongkongAcaoPass
postData.taiwanPass=_this.taiwanPass
postData.militaryCard=_this.militaryCard
postData.studentCard=_this.studentCard






if(_this.isMy){
postData.acquiesce = 1
}else{
postData.acquiesce = 0
}
if(_this.idCard!=postData.idCard && postData.phone!=_this.phone){
_this.existByOnly(info,postData,0)
}else if(_this.idCard!=postData.idCard && postData.phone==_this.phone && info.access_token){
_this.$http.get('/api/wtcp-member/public/contacts/existByIdCard?access_token=' + info.access_token + '&userId='+ info.user.id +'&idCard='+_this.idCard).then((response) => {
if (response.data.status == 1) {
_this.editBysubmit(info,postData)
}else{
_this.tipsShow=false
payPublic.showPrompt(response.data.msg)
_this.repeatShow = false
}
})
}else if(_this.idCard==postData.idCard && postData.phone!=_this.phone){
_this.$http.get('/api/wtcp-member/public/contacts/existByPhone?access_token=' + info.access_token + '&userId='+ info.user.id +'&phone='+_this.phone).then((res) => {
if (res.data.status ==1) {
_this.editBysubmit(info,postData)
}else{
_this.tipsShow=false
payPublic.showPrompt(res.data.msg)
_this.repeatShow = false
}
})
}else{
_this.editBysubmit(info,postData)
}
}else{
if(_this.isMy){
postData.acquiesce = 1
}else{
postData.acquiesce = 0
}
_this.existByOnly(info,postData,1)
}

},

editBysubmit(info,postData){
const _this = this
postData.idCard=_this.idCard
postData.phone=_this.phone
_this.$http.put('/api/wtcp-member/public/contacts/'+postData.id +'/'+info.user.id+'?access_token=' + info.access_token, postData).then((response) => {
if (response.data.status === 1) {
const data = response.data.data
if (data.id === _this.contactId) {
_this.setContact(data)
}

setTimeout(function () {
_this.tipsShow=false
_this.repeatShow = false
_this.$router.go(-1)
}, 1500)
} else {
_this.tipsShow=false
payPublic.showPrompt('提交失败，请重试')
_this.repeatShow = false
}
})
},

existByOnly(info,postData,type){
const _this = this
_this.$http.get('/api/wtcp-member/public/contacts/existByIdCard?access_token=' + info.access_token+'&userId='+info.user.id+'&idCard='+_this.idCard).then((response) => {
if (response.data.status == 1) {
_this.$http.get('/api/wtcp-member/public/contacts/existByPhone?access_token=' + info.access_token+'&userId='+info.user.id+'&phone='+_this.phone).then((res) => {
if (res.data.status ==1) {
if(type==0){
_this.editBysubmit(info,postData)
}else{
_this.submit(info,postData)
}
}else{
_this.tipsShow=false
payPublic.showPrompt(res.data.msg)
_this.repeatShow = false
}
})
}else{
_this.tipsShow=false
payPublic.showPrompt(response.data.msg)
_this.repeatShow = false
}
})
},
submit(info,postData){
const _this = this
postData.idCard=_this.idCard
postData.phone=_this.phone
_this.$http.post('/api/wtcp-member/public/contacts/save?access_token=' + info.access_token, postData).then((response) => {
if (response.data.status === 1) {
setTimeout(function () {
_this.repeatShow = false
_this.tipsShow=false
const { query: { contactNum }} = _this.$route
const { query: { type }} = _this.$route
const fillList = {
contactNum,
type
}
localStorage.setItem('fillList', JSON.stringify(fillList))
_this.$router.go(-1)
}, 1500)
} else {
_this.tipsShow=false
payPublic.showPrompt('提交失败，请重试')
_this.repeatShow = false
}
})
}
}
}
